import { useId, useState, type FormEvent } from 'react';

type PairingFormProps = {
  busy: boolean;
  error: string | null;
  onSubmit: (code: string) => Promise<void>;
  onClearError: () => void;
};

export function PairingForm({ busy, error, onSubmit, onClearError }: PairingFormProps) {
  const inputId = useId();
  const [code, setCode] = useState('');

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    await onSubmit(code);
  }

  return (
    <form className="pairing-form" onSubmit={handleSubmit}>
      <label className="pairing-form__label" htmlFor={inputId}>
        Pairing code
      </label>
      <input
        id={inputId}
        className="pairing-form__input"
        name="pairingCode"
        type="text"
        inputMode="text"
        autoComplete="one-time-code"
        autoCapitalize="characters"
        autoCorrect="off"
        spellCheck={false}
        maxLength={12}
        placeholder="ABC123"
        value={code}
        disabled={busy}
        autoFocus
        onChange={(event) => {
          onClearError();
          setCode(event.target.value.toUpperCase());
        }}
      />
      {error ? (
        <p className="pairing-form__error" role="alert">
          {error}
        </p>
      ) : (
        <p className="pairing-form__hint">
          Enter the code shown when you add a screen in the dashboard.
        </p>
      )}
      <button className="pairing-form__submit" type="submit" disabled={busy || code.trim().length < 4}>
        {busy ? 'Pairing…' : 'Start playback'}
      </button>
    </form>
  );
}
